import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { useFlexClassName } from './utils';
import { FLEX_CLASS_PREFIX, flexRoot } from './constants';
import { FlexRoot } from './style';
import { useComponentTheme } from '../../utils/hooks';
export var Flex = forwardRef(function Flex(_ref, ref) {
  var className = _ref.className,
      direction = _ref.direction,
      justifyContent = _ref.justifyContent,
      alignContent = _ref.alignContent,
      alignItems = _ref.alignItems,
      flexWrap = _ref.flexWrap,
      restProps = _objectWithoutProperties(_ref, ["className", "direction", "justifyContent", "alignContent", "alignItems", "flexWrap"]);

  var theme = useComponentTheme(FLEX_CLASS_PREFIX);
  var classOverride = useFlexClassName(FLEX_CLASS_PREFIX, className);
  return React.createElement(FlexRoot, Object.assign({
    "data-testid": flexRoot
  }, restProps, {
    theme: theme,
    className: classOverride.Root,
    direction: direction,
    flexWrap: flexWrap,
    justifyContent: justifyContent,
    alignContent: alignContent,
    ref: ref,
    alignItems: alignItems
  }));
});
Flex.defaultProps = {
  direction: 'row',
  flexWrap: 'nowrap'
};